import moment from 'moment'
import gql from 'graphql-tag'
import { useEffect, useState } from 'react'
import { useSubscription } from '@apollo/client'

import { User_users } from '../hasura/graphQlQueries/types/User'
import { usePrevious } from './usePrevious'

export interface CaseImageDownload {
  id: number
  aws_s3_url: string
  case: {
    id: number
    consultation?: {
      id: number
      consultation_type_id: number
    }
  }
}
const CASE_IMAGE_DOWNLOADS_UPDATED = (user_id: string, created_at: string) => gql`
  subscription OnCaseImageDownloadsUpdated {
    case_image_downloads(where: {downloaded_by_user_id: {_eq: "${user_id}"}, created_at: {_gt: "${created_at}"}}) {
      id
      created_at
      aws_s3_url
      case {
        id
        consultation {
          id
          consultation_type_id
        }
      }
    }
  }
`

const download = (url: string) => {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', '')
  a.click()
}

const MAX_DOWNLOAD_MINUTES = 20

export const useCaseImageDownloads = (caseImageDownloadCallback: (caseImageDownloads: any) => void, user: User_users) => {
  const [caseImageDownloads, setCaseImageDownloads] = useState<CaseImageDownload[]>([])

  const caseImageDownloadsSubscription = useSubscription(CASE_IMAGE_DOWNLOADS_UPDATED(user.id, moment().format('YYYY-MM-DD')))
  const previousCaseImageDownloads: CaseImageDownload[] | undefined = usePrevious(caseImageDownloads)

  useEffect(() => {
    const recent = moment().utc().subtract(MAX_DOWNLOAD_MINUTES, 'minutes')
    const data = caseImageDownloadsSubscription.data?.case_image_downloads.filter((d: any) => moment(d.created_at).isAfter(recent))

    if (data) {
      caseImageDownloadCallback(data)

      if (previousCaseImageDownloads) {
        const newDownloads = data.filter(
          // @ts-ignore
          (d: any) => d.aws_s3_url && !previousCaseImageDownloads.find((p: any) => p.id === d.id)?.aws_s3_url
        )

        newDownloads.forEach((d: CaseImageDownload) => {
          if (d.case.consultation?.consultation_type_id === 1) return

          download(d.aws_s3_url)
        })
      }
    }

    setCaseImageDownloads(data)
  }, [user, caseImageDownloadsSubscription.data?.case_image_downloads])
}
